var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.updatingCard
        ? _c("UpdateCardModal", {
            on: {
              cancel: function ($event) {
                _vm.updatingCard = false
              },
              create: _vm.updateCard,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.updatingBilling
        ? _c("UpdateBillingModal", {
            on: {
              cancel: function ($event) {
                _vm.updatingBilling = false
              },
              create: _vm.updateBilling,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.trialSkipModal
        ? _c("TrialSkipModal", {
            on: {
              reject: function ($event) {
                _vm.trialSkipModal = false
              },
              confirm: _vm.skipTrial,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.billModal
        ? _c("CreateInvoiceModal", {
            on: {
              cancel: function ($event) {
                _vm.billModal = false
              },
              create: _vm.createInvoice,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.configrationModal
        ? _c("ConfigurationBilling", {
            on: {
              close: function ($event) {
                _vm.configrationModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "billing" } }, [
        _vm.trialInfo.remainingDays > 0 && _vm.isRoot
          ? _c("div", { staticClass: "trial-information" }, [
              _c("div", { staticClass: "information" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("lightbulb"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("billing.youAreCurrentlyOnTrial")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "skip-now",
                  on: {
                    click: function ($event) {
                      _vm.trialSkipModal = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.skipNow")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("currentPlan")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("billing.availablePackages"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["currentPlan"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["currentPlan"] },
            },
            [
              _c("CurrentPlans", {
                class: "current-plans",
                on: { show: _vm.showPlans },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("additional")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("billing.additionalPackages"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["additional"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["additional"] },
            },
            [_c("Features", { class: "feature-items" })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("invoiceDetail")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("billing.invoiceInformation"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["invoiceDetail"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["invoiceDetail"] },
            },
            [
              _c("div", { staticClass: "invoice-details" }, [
                _c("div", { staticClass: "billing-section" }, [
                  _c(
                    "div",
                    { staticClass: "content", staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("billing.invoiceAddress"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bills-content" }, [
                          _c("div", { staticClass: "bills" }, [
                            _vm.billingDetail &&
                            _vm.billingDetail.billingAddress
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bill",
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "top",
                                      "justify-content": "space-between",
                                      padding: "20px 0px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "padding-right": "30px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                    " +
                                                _vm._s(
                                                  _vm.billingDetail
                                                    .billingType == "company"
                                                    ? _vm.billingDetail.name
                                                    : _vm.billingDetail.name +
                                                        " " +
                                                        _vm.billingDetail
                                                          .surname
                                                ) +
                                                "\n                                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                                    " +
                                              _vm._s(
                                                _vm.billingDetail.billingAddress
                                              ) +
                                              " -\n                                                    " +
                                              _vm._s(
                                                _vm.billingDetail.billingCountry
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.billingDetail.billingCity
                                              ) +
                                              "\n                                                "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "supsis-ghost-button",
                                on: {
                                  click: function ($event) {
                                    _vm.updatingBilling = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                edit\n                                            "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm.billingDetail &&
                                        _vm.billingDetail.billingAddress
                                        ? _vm.$t("message.edit")
                                        : _vm.$t("billing.addNewAddress")
                                    ) +
                                    "\n                                        "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "billing-section",
                    staticStyle: { width: "100%" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("billing.paymentMethod")) +
                                "\n                                    "
                            ),
                            _c(
                              "div",
                              { staticClass: "iyzico-pay" },
                              [_c("IyzicoPay")],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bills-content" }, [
                            _c("div", { staticClass: "bills" }, [
                              _vm.billingDetail && _vm.billingDetail.binNumber
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "bill",
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "space-between",
                                        padding: "20px 0px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "padding-right": "30px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "payment-method",
                                                },
                                                [
                                                  _c("DynamicSvg", {
                                                    attrs: {
                                                      name: _vm.formatCardType(
                                                        _vm.billingDetail
                                                          .cardAssociation
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          _vm.formatCardNumber(
                                                            _vm.billingDetail
                                                              .binNumber
                                                          )
                                                        ) +
                                                        "\n                                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color:
                                                        "rgb(160, 160, 160)",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          _vm.formatCardType(
                                                            _vm.billingDetail
                                                              .cardAssociation
                                                          )
                                                        ) +
                                                        "\n                                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "supsis-ghost-button",
                                  attrs: {
                                    disabled:
                                      _vm.billingDetail &&
                                      !_vm.billingDetail.name,
                                  },
                                  on: { click: _vm.openCardModal },
                                },
                                [
                                  _vm.billingDetail && _vm.billingDetail.name
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            "font-size": "16px",
                                            "margin-right": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                edit\n                                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(
                                        _vm.billingDetail &&
                                          _vm.billingDetail.binNumber
                                          ? _vm.$t("message.edit")
                                          : _vm.$t("billing.newPaymentMethod")
                                      ) +
                                      "\n                                        "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.forecastDetails
          ? _c("div", { staticClass: "billing-section" }, [
              _c(
                "div",
                {
                  staticClass: "title-head",
                  on: {
                    click: function ($event) {
                      return _vm.toggleCollopes("futureInvoice")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("billing.futureInvoice"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "collopse" }, [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.collopes["futureInvoice"]
                              ? "arrow_right"
                              : "arrow_drop_down"
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content",
                  class: { closed: _vm.collopes["futureInvoice"] },
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("billing.futureInvoice")) +
                            "\n                            "
                        ),
                        _c("span", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v(
                            "(" + _vm._s(_vm.forecastDetails.invoiceDate) + ")"
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bills-content" }, [
                      _c("div", { staticClass: "running-invoice" }, [
                        _c("div", { staticClass: "running-invoice-detail" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("billing.invoicePeriod")) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.forecastDetails.dateBetween)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("billing.invoiceStatus")) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("billing.expected"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [_vm._v(_vm._s(_vm.$t("billing.creationDate")))]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.forecastDetails.leftTime)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "running-invoice-price-details" },
                          [
                            _c(
                              "div",
                              { staticClass: "running-invoice-price-detail" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "running-invoice-detail-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "billing.monthlyEstimatedAmount"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "price" },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: {
                                        price:
                                          _vm.forecastDetails
                                            .endOfMonthForecast,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "10px" } },
                                  [
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { ghost: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showForecastDetails(
                                              "endOfMonthForecast"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("billing.viewDetails")
                                          ) +
                                            "\n                                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "running-invoice-price-detail" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "running-invoice-detail-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t("billing.currentAmount")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "price" },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: {
                                        price: _vm.forecastDetails.untilToday,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "10px" } },
                                  [
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { ghost: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showForecastDetails(
                                              "untilToday"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("billing.viewDetails")
                                          ) +
                                            "\n                                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showRunningInvoiceDetails
                        ? _c(
                            "div",
                            {
                              staticClass: "running-invoice-details",
                              class: { closed: !_vm.showRunningInvoiceDetails },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "running-invoice-details-title",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.showRunningInvoiceDetails ===
                                          "untilToday"
                                          ? _vm.$t(
                                              "billing.currentAmountDetails"
                                            )
                                          : _vm.$t(
                                              "billing.endOfMonthForecastDetails"
                                            )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.forecastDetails.details.plans,
                                function (planGroup) {
                                  return _c(
                                    "div",
                                    { staticClass: "detail-content" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "sub-item-detail zebra",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sub-item-name" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(planGroup.title) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "sub-item-price" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  (
                                                    planGroup.price || 0
                                                  ).toFixed(2)
                                                ) + "₺"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        _vm._l(
                                          planGroup.items,
                                          function (item) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "detail-content-child",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sub-item-detail",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sub-item-child-name",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                                    -\n                                                    "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.title
                                                              ) +
                                                                "\n                                                        " +
                                                                _vm._s(
                                                                  item.planType ===
                                                                    "storage"
                                                                    ? "(" +
                                                                        item.details.exceededSpace.toFixed(
                                                                          2
                                                                        ) +
                                                                        "GB)"
                                                                    : ""
                                                                ) +
                                                                "\n                                                        " +
                                                                _vm._s(
                                                                  item.planType ===
                                                                    "automation"
                                                                    ? _vm.isFreePlan(
                                                                        item
                                                                      )
                                                                      ? "(Free Plan)"
                                                                      : "(" +
                                                                        _vm.getSelectedCount(
                                                                          item
                                                                        ) +
                                                                        " Tasks)"
                                                                    : ""
                                                                ) +
                                                                "\n                                                        " +
                                                                _vm._s(
                                                                  item.planType ===
                                                                    "supsis"
                                                                    ? "(" +
                                                                        item
                                                                          .details
                                                                          .agentCount +
                                                                        " Agent) " +
                                                                        (item
                                                                          .details
                                                                          .freeAgentCount
                                                                          ? "(+" +
                                                                            item
                                                                              .details
                                                                              .freeAgentCount +
                                                                            " Ücretsiz)"
                                                                          : "")
                                                                    : [
                                                                        "whatsapp-business",
                                                                        "whatsapp",
                                                                        "instagram",
                                                                        "messenger",
                                                                        "trendyol",
                                                                      ].includes(
                                                                        item.planType
                                                                      )
                                                                    ? "(" +
                                                                      item
                                                                        .details
                                                                        .channelCount +
                                                                      " Kanal)"
                                                                    : item.planType ===
                                                                      "chatbot"
                                                                    ? "(" +
                                                                      item
                                                                        .details
                                                                        .totalChatbotSessionCount +
                                                                      " Chatbot)"
                                                                    : ""
                                                                ) +
                                                                "\n                                                        " +
                                                                _vm._s(
                                                                  item.planType ===
                                                                    "mail"
                                                                    ? _vm.isFreePlan(
                                                                        item
                                                                      )
                                                                      ? "(Free Plan)"
                                                                      : "(" +
                                                                        _vm.getSelectedCount(
                                                                          item
                                                                        ) +
                                                                        " Mail)"
                                                                    : ""
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]),
                                                        ]),
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              item.startDate
                                                                ? item.startDate +
                                                                    " - " +
                                                                    item.endDate
                                                                : ""
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sub-item-child-price",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              _vm.seperateWithCommas(
                                                                (
                                                                  item.price ||
                                                                  0
                                                                ).toFixed(2)
                                                              ) + "₺"
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "flex-end",
                                    "justify-content": "flex-end",
                                    "margin-top": "20px",
                                    gap: "10px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "14px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t("billing.totalAmount")
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.forecastDetails.details.prices.price.toFixed(
                                                  2
                                                )
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "15px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t("billing.vatAmount")
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.forecastDetails.details.prices.taxPrice.toFixed(
                                                  2
                                                )
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "14px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t(
                                                  "billing.totalAmountIncludingVAT"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.forecastDetails.details.prices.totalPrice.toFixed(
                                                  2
                                                )
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRunningInvoiceDetails
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "20px",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                                cursor: "pointer",
                                "font-size": "18px",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showRunningInvoiceDetails = null
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.hideDetails")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("invoices")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("billing.pastInvoices"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["invoices"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["invoices"] },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "bills-content" }, [
                  _c(
                    "div",
                    { staticClass: "bill-table" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-head",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            "padding-top": "20px",
                          },
                        },
                        [
                          _c("div", [
                            _vm.isAdmin
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bill-search",
                                    on: { click: _vm.createBillModal },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("add")]
                                    ),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t("billing.createInvoice")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "config-bill",
                              on: {
                                click: function ($event) {
                                  _vm.configrationModal = true
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("settings"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.invoices,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "iyzicoId",
                            fn: function (text, record) {
                              return _c("div", {}, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      record.paymentTransactionId || "n/A"
                                    ) +
                                    " / " +
                                    _vm._s(record.iyzicoId || "n/A") +
                                    "\n                                "
                                ),
                              ])
                            },
                          },
                          {
                            key: "paid",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  record.paid && !record.refund
                                    ? _c("div", {
                                        staticStyle: {
                                          background: "green",
                                          width: "10px",
                                          height: "10px",
                                          "border-radius": "100px",
                                          "margin-right": "5px",
                                        },
                                      })
                                    : record.refund
                                    ? _c("div", {
                                        staticStyle: {
                                          background: "yellow",
                                          width: "10px",
                                          height: "10px",
                                          "border-radius": "100px",
                                          "margin-right": "5px",
                                        },
                                      })
                                    : _c("div", {
                                        staticStyle: {
                                          background: "red",
                                          width: "10px",
                                          height: "10px",
                                          "border-radius": "100px",
                                          "margin-right": "5px",
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          record.paid && !record.refund
                                            ? "" + _vm.$t("billing.paid")
                                            : record.refund
                                            ? "" +
                                              _vm.$t(
                                                "billing.reimbursementMade"
                                              )
                                            : "" + _vm.$t("billing.unPaid")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]
                              )
                            },
                          },
                          {
                            key: "invalidPayment",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm.isAdmin
                                    ? _c("a-checkbox", {
                                        attrs: {
                                          checked: record.invalidPayment,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeInvalidPayment(
                                              record,
                                              $event
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "type",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "a-tag",
                                    { attrs: { color: "#EC4B1DFF" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatBillType(record.type)
                                          )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "_id",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(record._id.slice(12)) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            },
                          },
                          {
                            key: "price",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("MoneyFormatter", {
                                    attrs: { price: record.price },
                                  }),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "createdDate",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.formatDate(record.createdDate)
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            },
                          },
                          {
                            key: "isViewing",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  record.pdf
                                    ? _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                            color: "black",
                                            "text-decoration": "none",
                                          },
                                          attrs: {
                                            href:
                                              "https://static.supsis.live/" +
                                              record.pdf,
                                            target: "”_blank”",
                                            download: record.pdf
                                              .split("/")
                                              .pop(),
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            download\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t("billing.invoice")
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "margin-right": "10px",
                                        "user-select": "none",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push(
                                            "/billing/invoice/" + record._id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            "font-size": "16px",
                                            "margin-right": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            visibility\n                                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.$t("billing.review")) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !record.paid
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.paymentBill(record._id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            paid\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.$t("billing.payNow")) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteInvoice(
                                                record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            delete\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.$t("message.delete")) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin && record.paid && !record.refund
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.refundInvoice(
                                                record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            payments\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t("billing.payBack")
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin && !record.paid && !record.refund
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.markPaidBill(
                                                record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            payments\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.$t("billing.paid")) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "a-popconfirm",
                                        {
                                          attrs: {
                                            placement: "bottomRight",
                                            "ok-text":
                                              _vm.$t("visitor.confirm"),
                                            cancelText:
                                              _vm.$t("message.cancel"),
                                          },
                                          on: {
                                            confirm: function ($event) {
                                              return _vm.updateInvoicePrice(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              slot: "icon",
                                              type: "question-circle-o",
                                            },
                                            slot: "icon",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            { slot: "title" },
                                            [
                                              _c("a-input-number", {
                                                model: {
                                                  value: _vm.invoicePrice,
                                                  callback: function ($$v) {
                                                    _vm.invoicePrice = $$v
                                                  },
                                                  expression: "invoicePrice",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "user-select": "none",
                                                cursor: "pointer",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                payments\n                                            "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t("billing.editPrice")
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }